// Плашка алерта над страницей: самое важное из открытых алертов платформы (нет доступа к подписке,
// токен скоро истечёт, правка готова…). Критичные не закрываются вручную — они уходят сами, когда проблема решена.
// Крестик скрывает плашку сразу, не дожидаясь ответа: api закрывает алерт и рассылает свежий статус всем
// вкладкам. Закрытая плашка не возвращается, пока поток не пришлёт статус без неё; не получилось — тост,
// и плашка снова на месте. Под ней сразу видна следующая, если есть.
import { IconButton, toast } from '@autoaff/ui';
import { Link } from '@tanstack/react-router';
import { CircleAlert, TriangleAlert, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { type AlertView, api } from '../api';
import { useAgentStatus } from '../streams';

const RANK: Record<AlertView['severity'], number> = { critical: 0, warning: 1, info: 2 };

export function AlertBar() {
  const { status } = useAgentStatus();
  // Закрытые владельцем, но ещё присланные потоком (ответ api или свежий статус не дошли)
  const [hidden, setHidden] = useState<ReadonlySet<string>>(() => new Set());
  const alerts = status?.alerts;

  // Свежий статус без закрытого алерта — помнить его больше незачем
  useEffect(() => {
    setHidden((h) => {
      if (!h.size) return h;
      const open = new Set((alerts ?? []).map((a) => a.id));
      const next = new Set([...h].filter((id) => open.has(id)));
      return next.size === h.size ? h : next;
    });
  }, [alerts]);

  const top = (alerts ?? [])
    .filter((a) => !hidden.has(a.id))
    .sort((a, b) => RANK[a.severity] - RANK[b.severity])[0];
  if (!top) return null;
  const Icon = top.severity === 'critical' ? CircleAlert : TriangleAlert;
  // Ссылка действия: путь, параметры (?show=risky) и якорь (#integrations)
  const [pathQ = '', hash] = (top.action?.to ?? '').split('#');
  const [path, qs] = pathQ.split('?');
  const search = qs ? Object.fromEntries(new URLSearchParams(qs)) : undefined;
  const dismiss = async (id: string) => {
    setHidden((h) => new Set(h).add(id));
    try {
      await api(`/api/alerts/${id}/dismiss`, {});
    } catch {
      setHidden((h) => {
        const next = new Set(h);
        next.delete(id);
        return next;
      });
      toast('Не получилось скрыть уведомление — попробуйте ещё раз');
    }
  };
  return (
    <div
      key={top.id}
      className={`alert-bar ${top.severity}`}
      role={top.severity === 'critical' ? 'alert' : 'status'}
    >
      <Icon aria-hidden />
      <div className="alert-text">
        <b>{top.title}</b>
        {top.body && <span className="hide-m">{top.body}</span>}
      </div>
      {top.action && path && (
        <Link to={path} hash={hash} search={search as never} className="btn btn-sm">
          {top.action.label}
        </Link>
      )}
      {top.severity !== 'critical' && (
        <IconButton label="Скрыть" onClick={() => void dismiss(top.id)}>
          <X />
        </IconButton>
      )}
    </div>
  );
}
